export const DEALS_ROW_DATA_FETCH_SUCCESS = 'DEALS_ROW_DATA_FETCH_SUCCESS'
export const CREATE_DEAL_REQUESTED = 'CREATE_DEAL_REQUESTED'
export const CREATE_DEAL_SUCCESS = 'CREATE_DEAL_SUCCESS'
export const COMPANIES_FETCH_REQUESTED = 'COMPANIES_FETCH_REQUESTED'
export const USERS_FETCH_REQUESTED = 'USERS_FETCH_REQUESTED'
export const DEAL_FOLLOWUP_DATE_UPDATE_REQUESTED = 'DEAL_FOLLOWUP_DATE_UPDATE_REQUESTED'
export const DEAL_FOLLOWUP_DATE_UPDATE_SUCCESS = 'DEAL_FOLLOWUP_DATE_UPDATE_SUCCESS'
export const DEAL_UPDATE_STATUS_REQUESTED = 'DEAL_UPDATE_STATUS_REQUESTED'
export const DEAL_UPDATE_STATUS_SUCCESS = 'DEAL_UPDATE_STATUS_SUCCESS'
export const DEALS_BOARD_ROW_DATA_FETCH_REQUESTED = 'DEALS_BOARD_ROW_DATA_FETCH_REQUESTED'
export const DEALS_BOARD_ROW_DATA_FETCH_SUCCESS = 'DEALS_BOARD_ROW_DATA_FETCH_SUCCESS'
export const DEALS_BOARD_FOR_USER_FETCH_REQUESTED = 'DEALS_BOARD_FOR_USER_FETCH_REQUESTED'
export const DEALS_BOARD_FOR_USER_FETCH_SUCCESS = 'DEALS_BOARD_FOR_USER_FETCH_SUCCESS'
export const DEAL_DATE_UPDATE_REQUESTED = 'DEAL_DATE_UPDATE_REQUESTED'
export const DEAL_DATE_UPDATE_SUCCESS = 'DEAL_DATE_UPDATE_SUCCESS'
export const DEAL_UPDATE_PROPOSALS_FOLLOWUP_REQUESTED = 'DEAL_UPDATE_PROPOSALS_FOLLOWUP_REQUESTED'
export const DEAL_REVERT_STATUS = 'DEAL_REVERT_STATUS'
export const DEAL_BOARD_CONTRACTOR_AWARDED_UPDATE_REQUESTED =
  'DEAL_BOARD_CONTRACTOR_AWARDED_UPDATE_REQUESTED'
export const DEAL_BOARD_TOGGLE_SELECT_DEAL = 'DEAL_BOARD_TOGGLE_SELECT_DEAL'
export const DEAL_BOARD_TOGGLE_SELECT_ALL_DEALS = 'DEAL_BOARD_TOGGLE_SELECT_ALL_DEALS'
export const DEAL_BOARD_FETCH_NEXT_PAGE = 'DEAL_BOARD_FETCH_NEXT_PAGE'
export const DEALS_BOARD_ADD_DEALS_TO_COLUMN = 'DEALS_BOARD_ADD_DEALS_TO_COLUMN'
export const DEALS_BOARD_FETCH_DEALS_HEADER = 'DEALS_BOARD_FETCH_DEALS_HEADER'
export const DEALS_BOARD_ADD_DEALS_HEADER_TO_COLUMNS = 'DEALS_BOARD_ADD_DEALS_HEADER_TO_COLUMNS'
export const DEALS_FOLLOWUP_DATE_UPDATE_REQUESTED = 'DEALS_FOLLOWUP_DATE_UPDATE_REQUESTED'
export const DEALS_FOLLOWUP_DATE_UPDATE_SUCCESS = 'DEALS_FOLLOWUP_DATE_UPDATE_SUCCESS'
export const DASHBOARD_UPDATE_NEW_DEALS_COUNTER = 'DASHBOARD_UPDATE_NEW_DEALS_COUNTER'
export const DEAL_STATUSES_FETCH_REQUESTED = 'DEAL_STATUSES_FETCH_REQUESTED'
export const DEAL_STATUSES_FETCH_SUCCESS = 'DEAL_STATUSES_FETCH_SUCCESS'
export const ORGANIZATION_STATUSES_FETCH_REQUESTED = 'ORGANIZATION_STATUSES_FETCH_REQUESTED'
export const ORGANIZATION_STATUSES_FETCH_SUCCESS = 'ORGANIZATION_STATUSES_FETCH_SUCCESS'
export const DEAL_BOARD_EXPAND_DEAL = 'DEAL_BOARD_EXPAND_DEAL'
export const DEALS_BOARD_FETCH_DEAL_TASKS_REQUESTED = 'DEALS_BOARD_FETCH_DEAL_TASKS_REQUESTED'
export const DEALS_BOARD_FETCH_DEAL_TASKS_SUCCESS = 'DEALS_BOARD_FETCH_DEAL_TASKS_SUCCESS'
